import substationImg from "../../../assets/images/service/substation.jpg";
import {
  Settings,
  Zap,
  FileCheck,
  ShieldCheck,
  Clock,
  HardHat,
  TrendingUp,
  Maximize,
  UserCheck,
  TowerControl, // Represents the structural control
  Construction // Represents civil works
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function SubstationInfrastructure() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Advanced <span className="green">Substation Building</span> & Infrastructure
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise specializes in the design and construction of specialized 
                    electrical substation buildings, providing robust housing for HT/LT 
                    panels, transformers, and control equipment.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Industrial-grade civil construction & structural design</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Specialized fire-rated and weather-proof enclosures</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Integrated cable trenching and ventilation systems</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={substationImg}
                      alt="Electrical Substation Building"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-building"></i> Reliable Power Housing
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">About the Service</h3>
                    <p className="mb-3">
                      A substation building is the backbone of any industrial power setup. Denial Enterprise manages the end-to-end civil and electrical integration required for indoor and outdoor substations. We ensure that every structure is built to withstand environmental stresses while providing optimal accessibility for maintenance.
                    </p>
                    <p className="mb-3">
                      From the initial soil testing and site leveling to the construction of control rooms and transformer plinths, our engineering team ensures that the infrastructure meets the specific technical requirements of your 66kV or 33kV connections.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Construction size={22} />
                        </span>
                        <span>Civil Construction of Control Rooms & Plinths</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TowerControl size={22} />
                        </span>
                        <span>Structural Gantry & Tower Foundations</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Zap size={22} />
                        </span>
                        <span>Advanced Grounding & Lightning Protection</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Compliance with IS & CEA Safety Standards</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">How You Benefit</h4>
                    <p className="mb-6">
                      Our turnkey construction approach ensures that your substation is not just a building, but a high-performance environment that protects your multi-million dollar electrical assets from heat, moisture, and fire risks.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Maximum protection for sensitive HT/LT switchgear</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Synchronized civil and electrical execution timelines</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Optimized layout for easy equipment maintenance</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Durability and compliance with utility norms</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Future-proof space planning for load expansion</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Adherence to rigorous safety and quality protocols</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}